import { request } from '@/util/vueRequest.js'

import { httpRequest } from '../request'

enum Apis {
  getLabelInfoAPI = '/backend/label/info?from=user',
  specialRemarks = '/special/remarks',
  getLabelList = 'get_electronic_saw_label',
  getFileStartNum = 'file_start_num',
  tagTemplate = 'load_tag_setting',
  plankReference = 'plank_reference',
  ezsortPassport = 'ezsort/auth',
  tagOpacityPermission = 'tag_opacity_permission',
  GetTagTemplateList = 'get_tag_setting_list',
  LoadTagSetting = 'load_tag_setting',
  DeleteTagSetting = 'delete_tag_setting',
}

export function getLabelInfo() {
  return request({
    url: Apis.getLabelInfoAPI,
    method: 'GET',
  })
}

/**
 * @description 获取柜柜料单特殊工艺筛选信息
 * @link https://api.thinkerx.com/web/#/162/10903
 */
export function getSpecialRemarks() {
  return request({
    url: Apis.specialRemarks,
    method: 'GET',
  })
}

export function getElectronicSawLabel(payload: string) {
  return httpRequest.get(Apis.getLabelList, {
    label_class: payload,
  })
}

export function getFileStartNum(payload: {
  plateTypeNum: number
  fileStartNum: string
}) {
  return httpRequest.get(Apis.getFileStartNum, payload)
}

/**
 * @description 获取标签模版
 * @param data
 * @returns
 */
export function fetchTagTemplate(data: {
  id: number | string
  default?: 0 | 1
  process_line_id?: number | string
}) {
  return httpRequest.get(Apis.LoadTagSetting, { default: 1, ...data })
}
export function getTagTemplateList(payload: any) {
  return httpRequest.get(Apis.GetTagTemplateList, payload)
}

export function loadTagSetting(payload: any) {
  return httpRequest.get(Apis.LoadTagSetting, payload)
}

export function deleteTagSetting(payload: any) {
  return httpRequest.get(Apis.DeleteTagSetting, payload)
}

/**
 * 获取小板放板基准
 */
export function fetchPlankReference(payload: {
  process_setting_id: number
  bigPlanks: any[]
}) {
  return httpRequest.post(Apis.plankReference, {
    process_setting_id: payload.process_setting_id,
    bigPlanks: JSON.stringify(payload.bigPlanks),
  })
}

// 获取彩标权限
export function fetchGetEzsortPassport() {
  return httpRequest.get(Apis.ezsortPassport)
}
